import { createUseStyles } from 'react-jss'

export default createUseStyles({
  baseImageViewer: {
    height: '100%',
    width: '100%',
    position: 'relative'
  }
})
